export const depth = (mgmt, ...args) => {
    let [index, factor] = args;
    mgmt.dimensionFactors[index] = [0, 0, factor];
    let dimensions = mgmt.dimensions[index];
    if (!dimensions) {
        return;
    }
    let depth = mgmt.dimensions[index][2];
    let [uniformW, uniformH, uniformD] = mgmt.dimensionsUniforms[index];

    // update uniform
    uniformD([depth * factor]);
};

export const index = {
    depth
};
